import RequestMapAddress from './RequestMapAddress';
/**
 * 세부지명 요청 도메인 모델
 * 바로고 지도 조회와 세부지명 요청 조회 데이터 구조 같음
 * */
export default class RequestMap {
    /** 아이디 */
    id = 0;
    /** 원본 아이디 */
    originId = 0;
    /** 주소 타입 */
    type = '';
    /** 작업 타입 (추가, 수정) */
    operationType = 'CREATE';
    /** 작업 상세 타입 (지명, 행정구역, 0번지) */
    operationDetailType = 'PLACE_NAME';
    /** 작업 결과 */
    resultType = '';
    /** 지역 타입 */
    areaType = '';
    /** 생성자 */
    createdBy = '';
    /** 생성일 */
    createdAt = 0;
    /** 수정일 */
    updatedAt = 0;
    address = null;
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 변환
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
            address: new RequestMapAddress(data.address),
        };
    }
}
